"use strict";
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMinLogLevelFromEnv = void 0;
var LogLevel_1 = require("./LogLevel");
var data = typeof process === 'undefined'
    ? []
    : (_b = (_a = process.env.LOGGING) === null || _a === void 0 ? void 0 : _a.split(';').map(function (part) {
        var _a = part.split('=', 2), namespace = _a[0], strLevel = _a[1];
        if (strLevel) {
            return [namespace === 'default' ? undefined : namespace.split(':'), LogLevel_1.resolveLogLevel(strLevel)];
        }
        return null;
    }).filter(function (v) { return !!v; }).sort(function (_a, _b) {
        var _c, _d;
        var a = _a[0];
        var b = _b[0];
        return ((_c = b === null || b === void 0 ? void 0 : b.length) !== null && _c !== void 0 ? _c : 0) - ((_d = a === null || a === void 0 ? void 0 : a.length) !== null && _d !== void 0 ? _d : 0);
    })) !== null && _b !== void 0 ? _b : [];
var defaultIndex = data.findIndex(function (_a) {
    var nsParts = _a[0];
    return !nsParts;
});
var defaultLevel = undefined;
if (defaultIndex !== -1) {
    defaultLevel = data[defaultIndex][1];
    data.splice(defaultIndex);
}
function isPrefix(value, prefix) {
    return prefix.length <= value.length && prefix.every(function (item, i) { return item === value[i]; });
}
function getMinLogLevelFromEnv(name) {
    var nameSplit = name.split(':');
    for (var _i = 0, data_1 = data; _i < data_1.length; _i++) {
        var _a = data_1[_i], nsParts = _a[0], level = _a[1];
        if (isPrefix(nameSplit, nsParts)) {
            return level;
        }
    }
    return defaultLevel;
}
exports.getMinLogLevelFromEnv = getMinLogLevelFromEnv;
//# sourceMappingURL=getMinLogLevelFromEnv.js.map